import {NEVER, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {Injectable, inject} from '@angular/core';

import * as AIM from '@common/utils/dist/models/ai-models.js';
import * as APIM from '@common/utils/dist/models/api-messages.js';

import {WSMessageReceiverService} from '@services/ws-message-receiver.service';
import {EventTrackingStore} from '@stores/event-tracking.store';

import {
  WebsocketMessageProcessor,
  WSMessageProcessorInput,
  WSMessageProcessorOutput,
} from './websocket-message-processor';

@Injectable()
export class AIAnswersAndRubricsMessageProcessor implements WebsocketMessageProcessor {
  private _wsMessageReceiverService = inject(WSMessageReceiverService);
  private _eventTrackingStore = inject(EventTrackingStore);

  processMessage(
    params: WSMessageProcessorInput,
  ): Observable<WSMessageProcessorOutput> {
    const msg = params.msg;
    if (msg.int !== APIM.EventIntent.AIAnswersAndRubricsGenerated) {
      return NEVER;
    }

    return this._wsMessageReceiverService.receive(msg).pipe(
      map((eventData) => {
        params.wsAPI.result(msg, eventData);
        this._eventTrackingStore.settleEvent(msg.id);
        return true;
      }),
    );
  }
}
